import React, { useEffect, useState } from 'react'
import Swiper from 'swiper'
import useStore from 'store'
import 'swiper/css/swiper.css'
import { addRlog } from 'utils/util'
import s from './index.module.less'

const SwiperBox: React.FC<{}> = () => {
  const [swiperObj, setSwiper] = useState(Object)
  const { state } = useStore()
  const { bannerList } = state.cmsData

  const initSwiper = () => {
    const thisSwiper = new Swiper('.swiper-container', {
      slidesPerView: 1,
      loop: true,
      autoplay: {
        // 自动滑动
        delay: 3000, // 3秒切换一次
        // stopOnLastSlide: false,
        disableOnInteraction: false //
      },
      observer: true, // 修改swiper自己或子元素时，自动初始化swiper    重要
      observeParents: true, // 修改swiper的父元素时，自动初始化swiper  重要
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      pagination: {
        el: '.swiper-pagination'
      }
    })
    setSwiper(thisSwiper)
  }

  const slideClick = (url) => {
    addRlog('click', {
      click_location: 'banner',
      banner_url: url
    })
  }

  useEffect(() => {
    if (bannerList?.length) {
      initSwiper()
      if (typeof swiperObj.update === 'function') swiperObj.update()
    }
  }, [bannerList])

  return (
    <div className={s.SwiperBox}>
      <div className={`${s.SwiperBoxConter} swiper-container swiper-no-swiping`}>
        <div className="swiper-wrapper">
          {bannerList?.map((item) => (
            <div className="swiper-slide" key={`swiper${item.url}`}>
              <a
                href={item.target}
                target="_blank"
                rel="noreferrer"
                onClick={() => slideClick(item.url)}
              >
                <img className={s.SwiperBoxConterImg} src={item.url} alt="img" />
              </a>
            </div>
          ))}
        </div>
        <div className="swiper-pagination" />
        <div className="swiper-button-prev" />
        <div className="swiper-button-next" />
      </div>
    </div>
  )
}

export default SwiperBox
